var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"#F8F8F8"},attrs:{"id":"app"}},[(this.$route.query.incrustado == undefined)?_c('Modulos'):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('Notificacion')],1)}
var staticRenderFns = []

export { render, staticRenderFns }